import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useSessionStore } from '@/stores/session';
import { logout } from './api';
import { LOGGED_OUT_PATH } from './effeta-login';

// Salir del PIM: `POST /auth/logout`, olvidar el pase y mostrar "Saliste del
// PIM". Nunca manda sola a entrar: la sesión de Effetá Apps sigue abierta y la
// persona volvería a entrar en el acto.
export function useLogout() {
  const navigate = useNavigate();
  return useMutation<void, Error, void>({
    // Best-effort: si falla (red), igual se olvida el pase local.
    mutationFn: async () => {
      try {
        await logout();
      } catch {
        // Ignorado a propósito: el logout local debe ejecutarse sí o sí.
      }
    },
    onSettled: () => {
      // Primero salir del árbol protegido: si el store se vacía antes, el
      // guard alcanza a redirigir a la pantalla de entrada.
      navigate(LOGGED_OUT_PATH, { replace: true });
      useSessionStore.getState().logout({ reason: 'manual' });
    },
  });
}
